module.exports = __webpack_public_path__ + "static/hotfoil-4dafc3302c0131910ce18644a7e11fe7.jpg";